'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var styled = require('styled-components');
var Checkbox = require('@narvar/nth-block-checkbox');
var TextInput = require('@narvar/nth-block-text-input');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var Typography = require('../../../../../common/components/Typography.js');
var ClaimSummarySection = require('../../../../../common/views/ClaimSummary/components/ClaimSummarySection.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var Checkbox__default = /*#__PURE__*/_interopDefaultLegacy(Checkbox);
var TextInput__default = /*#__PURE__*/_interopDefaultLegacy(TextInput);

const SignatureContainer = styled__default["default"].div.withConfig({
  componentId: "sc-1mypoqu-0"
})(["background:#ececec;border-radius:10px;padding:1rem;display:flex;flex-direction:column;gap:1rem;"]);
const DetailsList = styled__default["default"].ul.withConfig({
  componentId: "sc-1mypoqu-1"
})(["margin:0;padding:0 0 0 1.25rem;list-style:none;position:relative;"]);
const Detail = styled__default["default"].li.withConfig({
  componentId: "sc-1mypoqu-2"
})(_ref => {
  let {
    s
  } = _ref;
  return {
    ...s,
    '::before': {
      content: '"•"',
      fontSize: '1.25em',
      position: 'absolute',
      left: '0.5rem'
    }
  };
});
const ClaimSummarySignature = _ref2 => {
  let {
    signatureValue,
    signatureOnChange,
    confirmationChecked,
    confirmationOnChange
  } = _ref2;
  const {
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  const {
    retailerName
  } = nthHookGlobalSettings.useGlobalSettings();
  const {
    claimsSummarySignatureBullet0,
    claimsSummarySignatureBullet1,
    claimsSummarySignatureBullet2,
    claimsSummarySignatureBullet3,
    claimsSummarySignatureConfirmationCheckboxLabel,
    claimsSummarySignatureInputHeading,
    claimsSummarySignatureInputLabel,
    claimsSummarySignatureSectionHeading
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement(ClaimSummarySection["default"], null, /*#__PURE__*/React__default["default"].createElement(SignatureContainer, null, /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Typography.TertiaryHeader, {
    s: {
      textTransform: 'none',
      margin: '0 0 0.75rem 0'
    }
  }, claimsSummarySignatureSectionHeading), /*#__PURE__*/React__default["default"].createElement(DetailsList, null, /*#__PURE__*/React__default["default"].createElement(Detail, {
    s: bodytextDefaultNone
  }, mustache__default["default"].render(claimsSummarySignatureBullet0 ?? '', {
    retailerName
  })), /*#__PURE__*/React__default["default"].createElement(Detail, {
    s: bodytextDefaultNone
  }, claimsSummarySignatureBullet1), /*#__PURE__*/React__default["default"].createElement(Detail, {
    s: bodytextDefaultNone
  }, mustache__default["default"].render(claimsSummarySignatureBullet2 ?? '', {
    retailerName
  })), claimsSummarySignatureBullet3 && /*#__PURE__*/React__default["default"].createElement(Detail, {
    s: bodytextDefaultNone
  }, claimsSummarySignatureBullet3))), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Typography.TertiaryHeader, {
    s: {
      textTransform: 'none',
      margin: '0 0 0.75rem 0'
    }
  }, claimsSummarySignatureInputHeading), /*#__PURE__*/React__default["default"].createElement(TextInput__default["default"], {
    id: "signature",
    type: TextInput.SupportedInputType.text,
    label: claimsSummarySignatureInputLabel ?? '',
    animateLabel: true,
    value: signatureValue,
    onChange: signatureOnChange,
    containerOverridesStyle: {
      background: '#fff'
    }
  })), /*#__PURE__*/React__default["default"].createElement(Checkbox__default["default"], {
    id: "confirmation",
    onChange: confirmationOnChange,
    checked: confirmationChecked,
    labelBoxCellStyle: {
      background: '#fff',
      display: 'inline-block',
      borderRadius: '5px'
    },
    boxStyle: {
      borderRadius: '5px',
      color: '#006AAC',
      borderColor: '#006AAC',
      width: '1rem',
      height: '1rem'
    },
    checkStyle: {
      width: '0.75rem'
    }
  }, claimsSummarySignatureConfirmationCheckboxLabel)));
};
var ClaimSummarySignature$1 = nthHookGlobalSettings.withGlobalSettingsProvider(nthHookTheme.withThemeProvider(nthHookTranslations.withTranslationsProvider(ClaimSummarySignature, {
  translationKeys: ['claimsSummarySignatureBullet0', 'claimsSummarySignatureBullet1', 'claimsSummarySignatureBullet2', 'claimsSummarySignatureBullet3', 'claimsSummarySignatureConfirmationCheckboxLabel', 'claimsSummarySignatureInputHeading', 'claimsSummarySignatureInputLabel', 'claimsSummarySignatureSectionHeading']
}), {
  themeTokens: ['bodytextDefaultNone']
}), {
  globalSettingsRequested: 'retailerName'
});

exports["default"] = ClaimSummarySignature$1;
